import { LOGOUT } from '#modules/state/LogOutAction';

const initialState = {};

const DISMISS = 'tokenized/warnings/DISMISS';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DISMISS:
      if (!action.payload.messageName || !action.payload.profileId) {
        return state;
      }
      return {
        ...state,
        [action.payload.profileId]: {
          ...state[action.payload.profileId],
          [action.payload.messageName]: true,
        },
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function dismissWorkspaceWarningAction(messageName, profileId) {
  return { type: DISMISS, payload: { messageName, profileId } };
}

export const selectMessageIsDismissed = (state, messageName, profileId) =>
  !!state.warnings?.[profileId]?.[messageName];
